import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import home from './home'
import account from './account'
import systemAdmin from './system/admin'
import systemModule from './system/module'
import systemRole from './system/role'
import merchantManage from './merchant/manage'
import merchantRecharge from './merchant/recharge'
import error from './error'
import childrenSystem from './system/childrenSystem'
import merchantBill from './merchant/bill'

Vue.use(Router)

const router = new Router({
  routes: [
    ...home,
    ...account,
    ...systemAdmin,
    ...systemModule,
    ...systemRole,
    ...merchantManage,
    ...merchantRecharge,
    ...error,
    ...childrenSystem,
    ...merchantBill
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    store.dispatch('account/getAccessToken')
    if (store.state.account.access_token) {
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js